import React from "react";
import get from "lodash/get";
import filter from "lodash/filter";
import { connect } from "react-redux";
import {
  Alert,
  Layout,
  Table,
  Tooltip,
  Icon,
  Button,
  Breadcrumb,
  Modal,
  Switch,
  message,
  Badge,
} from "antd";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import Footer from "../../components/Footer/Footer";
import classes from "./CustomFormList.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  customFormList,
  customFormApprove,
  customFormDisapprove,
  customFormUnlock,
  customFormLock,
  customFormDelete,
  customFormActivate,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getCustomFormsReadPermission,
  getCustomFormsCreatePermission,
  getCustomFormsUpdatePermission,
  getCustomFormsDeletePermission,
  getCustomFormsLockPermission,
  getCustomFormsApprovePermission,
} from "../../reducers/user/selectors";
import { withParams } from "../../utils/url";
import FormBuilderCustomView from "../FormBuilder/FormBuilderCustomView";

const routes = require("../../routes.json");

const { Content } = Layout;

class CustomFormList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      customForms: [],
      errorMessage: null,
      schema: null,
      name: null,
      isLoading: false,
    };
  }

  componentDidMount() {
    this.customFormList();
  }

  customFormList = async () => {
    this.setState({
      isLoading: true,
    });

    try {
      const { data } = await customFormList();

      this.setState({
        customForms: data,
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        customForms: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  setPreviewForm = (schema, name) => () => {
    this.setState({
      schema,
      name,
    });
  };

  onSwitchApprove = (id, approved) => async () => {
    try {
      if (!approved) {
        await customFormApprove(id);
      } else {
        await customFormDisapprove(id);
      }

      message.success(this.props.i18n.t("Saved"));

      this.customFormList();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
      console.log(e);
    }
  };

  onSwitchLock = (id, locked) => async () => {
    try {
      if (locked) {
        await customFormUnlock(id);
      } else {
        await customFormLock(id);
      }

      message.success(this.props.i18n.t("Saved"));

      this.customFormList();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
      console.log(e);
    }
  };

  onSwitchDelete = (id, deleted) => async () => {
    try {
      if (deleted) {
        await customFormActivate(id);
      } else {
        await customFormDelete(id);
      }

      message.success(this.props.i18n.t("Saved"));

      this.customFormList();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }

      message.error(JSON.stringify(get(e, "response.data.error")));
    }
  };

  render() {
    const { customForms, isLoading, errorMessage, schema, name } = this.state;

    const columns = [
      {
        dataIndex: "name",
        key: "name",
        title: this.props.i18n.t( "Name"),
        render: (val, row) => (
          <div className={classes.name}>
            {val}
            &nbsp;&nbsp;
            <Badge
              count={row.locked ? this.props.i18n.t('Locked') : this.props.i18n.t("Unlocked")}
              style={{
                backgroundColor: row.locked ? "#f00" : "#49c850",
                textTransform: "none",
              }}
            />
            &nbsp;&nbsp;
            <Badge
              count={!row.approved ? this.props.i18n.t('Unaproved') : this.props.i18n.t("Approved")}
              style={{
                backgroundColor: !row.approved ? "#f00" : "#49c850",
                textTransform: "none",
              }}
            />
          </div>
        ),
      },
      {
        dataIndex: "slug",
        key: "slug",
        title: "",
        render: (val, row) => (
          <div className={classes.actions}>
            {this.props.customFormsApprovePermission && (
              <div style={{ flex: "0 0 100px", fontSize: "13px" }}>
                <div>{this.props.i18n.t('Approve')}</div>
                <Tooltip
                  placement="topLeft"
                  title={row.approved ? this.props.i18n.t("Approved") : this.props.i18n.t("Unaproved")}
                >
                  <Switch
                    className={classes.reactivateBtn}
                    checked={row.approved}
                    onChange={this.onSwitchApprove(val, row.approved)}
                  />
                </Tooltip>
              </div>
            )}
            {this.props.customFormsLockPermission && (
              <div style={{ flex: "0 0 100px", fontSize: "13px" }}>
                <div>{this.props.i18n.t("Lock")}</div>
                <Tooltip
                  placement="topLeft"
                  title={!row.locked ? this.props.i18n.t("Unlocked") : this.props.i18n.t("Locked")}
                >
                  <Switch
                    className={classes.reactivateBtn}
                    checked={row.locked}
                    onChange={this.onSwitchLock(val, row.locked)}
                  />
                </Tooltip>
              </div>
            )}
            {this.props.customFormsDeletePermission && (
              <div style={{ flex: "0 0 100px", fontSize: "13px" }}>
                <div>{this.props.i18n.t("Deleted")}</div>
                <Tooltip
                  placement="topLeft"
                  title={!row.deleted ? this.props.i18n.t("Active") : this.props.i18n.t("Deleted")}
                >
                  <Switch
                    className={classes.reactivateBtn}
                    checked={row.deleted}
                    onChange={this.onSwitchDelete(val, row.deleted)}
                  />
                </Tooltip>
              </div>
            )}
            <Tooltip placement="topLeft" title={this.props.i18n.t("Preview")}>
              <Icon
                type="eye"
                theme="filled"
                className={classes.iconEdit}
                onClick={this.setPreviewForm(row.schema, row.name)}
              />
            </Tooltip>
            &nbsp;
            <Tooltip placement="topLeft" title={this.props.i18n.t("Edit")}>
              {this.props.customFormsUpdatePermission && (
                <Link
                  to={withParams(routes.admin.customFormsUpdate, {
                    slug: row.slug,
                  })}
                >
                  <Icon
                    type="edit"
                    theme="filled"
                    className={classes.iconEdit}
                  />
                </Link>
              )}
            </Tooltip>
          </div>
        ),
      },
    ];
    return (
      <div>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">{this.props.i18n.t("Custom Forms")}</h3>

            {errorMessage && <Alert type="error" message={errorMessage} />}
            <br />

            <h5 className="headline">
              {this.props.i18n.t(
                "NamespaceSettingsPatientEvents:Predefined Forms"
              )}
            </h5>
            <Table
              columns={columns}
              dataSource={filter(customForms, (form) => form.is_predefined)}
              loading={isLoading}
              rowKey="slug"
              className={classes.table}
            />
            <br />

            <h5 className="headline">
              {this.props.i18n.t("NamespaceSettingsPatientEvents:Custom Forms")}
            </h5>
            {this.props.customFormsCreatePermission && (
              <Link to={routes.admin.customFormsCreate}>
                <Button type="primary">{this.props.i18n.t("Add Custom Form")}</Button>
              </Link>
            )}
            <Table
              columns={columns}
              dataSource={filter(customForms, (form) => !form.is_predefined)}
              loading={isLoading}
              rowKey="slug"
              className={classes.table}
            />

            <Modal
              title={this.props.i18n.t("Form preview")}
              visible={!!schema}
              onCancel={() => {
                this.setState({ schema: null });
              }}
              footer={null}
              width={640}
            >
              {schema && (
                <FormBuilderCustomView isEditable name={name} schema={schema} />
              )}
            </Modal>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  customFormsReadPermission: getCustomFormsReadPermission(state),
  customFormsCreatePermission: getCustomFormsCreatePermission(state),
  customFormsUpdatePermission: getCustomFormsUpdatePermission(state),
  customFormsDeletePermission: getCustomFormsDeletePermission(state),
  customFormsLockPermission: getCustomFormsLockPermission(state),
  customFormsApprovePermission: getCustomFormsApprovePermission(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(CustomFormList))
);



// WEBPACK FOOTER //
// ./src/containers/CustomFormList/CustomFormList.js